import { useCallback } from 'react';
import { ChartType } from '..';
import { colors } from '../../../../../colors';
import ColoredCheckbox from '../../../../../components/ColoredCheckbox';
import './index.css';

interface Props {
  selectedChartTypes: ChartType[];
  setSelectedChartTypes: React.Dispatch<React.SetStateAction<ChartType[]>>;
  showAccumulativeData: boolean;
  setShowAccumulativeData: React.Dispatch<React.SetStateAction<boolean>>;
  totalBalanceColor: string;
  totalAssetBalanceColor: string;
  noAlgorithmicProgressionColors: string;
}

const ChartOptions: React.FC<Props> = (props: Props) => {
  const {
    selectedChartTypes,
    setSelectedChartTypes,
    showAccumulativeData,
    setShowAccumulativeData,
    totalBalanceColor,
    totalAssetBalanceColor,
    noAlgorithmicProgressionColors,
  } = props;

  const handleTogglePress = useCallback(
    (chartType: ChartType, value: boolean) => {
      if (value === true) {
        setSelectedChartTypes((prev) => [...prev, chartType]);
        return;
      }

      setSelectedChartTypes((prev) => {
        const updated = [...prev];
        updated.splice(
          prev.findIndex((c) => c === chartType),
          1,
        );

        return updated;
      });
    },
    [setSelectedChartTypes],
  );

  return (
    <div className="profit-chart-options-root">
      <div className="profit-chart-options-column">
        <div className="profit-chart-options-item">
          <ColoredCheckbox
            value={selectedChartTypes.includes(ChartType.TotalStableBalance)}
            handleValueChange={(v) =>
              handleTogglePress(ChartType.TotalStableBalance, v)
            }
            color={totalBalanceColor}
            size={10}
          />
          <span
            className="profit-chart-options-label"
            style={{
              color: selectedChartTypes.includes(ChartType.TotalStableBalance)
                ? totalBalanceColor
                : colors.white,
            }}
          >
            Total Stable Balance
          </span>
        </div>
        <div className="profit-chart-options-item">
          <ColoredCheckbox
            value={selectedChartTypes.includes(ChartType.TotalAssetBalance)}
            handleValueChange={(v) =>
              handleTogglePress(ChartType.TotalAssetBalance, v)
            }
            color={totalAssetBalanceColor}
            size={10}
          />
          <span
            className="profit-chart-options-label"
            style={{
              color: selectedChartTypes.includes(ChartType.TotalAssetBalance)
                ? totalAssetBalanceColor
                : colors.white,
            }}
          >
            Total Asset Balance
          </span>
        </div>
      </div>

      <div className="profit-chart-options-column">
        <div className="profit-chart-options-item">
          <ColoredCheckbox
            value={selectedChartTypes.includes(ChartType.StableBalance)}
            handleValueChange={(v) =>
              handleTogglePress(ChartType.StableBalance, v)
            }
            color={colors.tetherGreen}
            size={10}
          />
          <span
            className="profit-chart-options-label"
            style={{
              color: selectedChartTypes.includes(ChartType.StableBalance)
                ? colors.tetherGreen
                : colors.white,
            }}
          >
            Stable Balance
          </span>
        </div>
        <div className="profit-chart-options-item">
          <ColoredCheckbox
            value={selectedChartTypes.includes(ChartType.AssetBalance)}
            handleValueChange={(v) =>
              handleTogglePress(ChartType.AssetBalance, v)
            }
            color={colors.bitcoinOrange}
            size={10}
          />
          <span
            className="profit-chart-options-label"
            style={{
              color: selectedChartTypes.includes(ChartType.AssetBalance)
                ? colors.bitcoinOrange
                : colors.white,
            }}
          >
            Asset Balance
          </span>
        </div>
      </div>

      <div className="profit-chart-options-column">
        <div className="profit-chart-options-item">
          <ColoredCheckbox
            value={showAccumulativeData}
            handleValueChange={setShowAccumulativeData}
            color={colors.white}
            size={10}
          />
          <span
            className="profit-chart-options-label"
            style={{
              color: showAccumulativeData ? colors.white : colors.white,
            }}
          >
            Accumulate Data
          </span>
        </div>
        <div className="profit-chart-options-item">
          <ColoredCheckbox
            value={selectedChartTypes.includes(
              ChartType.NoAlgoritmicProgression,
            )}
            handleValueChange={(v) =>
              handleTogglePress(ChartType.NoAlgoritmicProgression, v)
            }
            color={noAlgorithmicProgressionColors}
            size={10}
          />
          <span
            className="profit-chart-options-label"
            style={{
              color: selectedChartTypes.includes(
                ChartType.NoAlgoritmicProgression,
              )
                ? noAlgorithmicProgressionColors
                : colors.white,
            }}
          >
            No Algorithm Progression
          </span>
        </div>
      </div>
    </div>
  );
};

export default ChartOptions;
